import { Moment } from 'moment';

export class UpdateCertificateRecordCommand {
    certification: {
        id: number;
    };
    issue_date: string;
    expiration_date: string;
    notify_about_expiration: boolean;

    constructor(certificationId: string, issueDate: Moment, expirationDate: Moment, notifyAboutExpiration: boolean) {
        this.certification = {
            id: parseInt(certificationId),
        };
        this.issue_date = issueDate.format();
        this.expiration_date = expirationDate ? expirationDate.format() : null;
        this.notify_about_expiration = notifyAboutExpiration;
    }
}
